module.exports = __webpack_public_path__ + "img/hzhb-banner-pic.34c38241.png";